<template>
  <div class="flex w-full items-center justify-between gap-2">
    <div class="flex items-center justify-between gap-2">
      <p
        class="text-ontick-blue-300 bg-ontick-blue-900 flex w-full min-w-[60px] items-center justify-center rounded-sm py-0.5 text-xs font-medium shadow-md"
      >
        {{ trail.trail_order_symbol }}
      </p>

      <div
        class="text-ontick-graphite-500 flex h-5 min-w-[20px] items-center justify-center rounded-sm bg-[#B9AB30] text-[10px] font-bold"
        :content="operation"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        {{ operation === "Compra" ? "C" : "V" }}
      </div>
    </div>
    <status-progress-bar-exec-trail-component
      :symbol="trail.trail_order_symbol"
      :price="trail.trail_order_price_avg"
      :volumeFilled="trail.trail_order_volume_filled"
      :totalVolume="trail.trail_order_volume_planned"
      :currentVolume="
        (trail.trail_order_volume_filled / trail.trail_order_volume_planned) *
        100
      "
      :active="true"
      :status="trail.order_trading_phase"
      :orderStatus="trail.trail_order_status"
    />
    <template>
      <!-- Bolinha azul -->
      <div
        v-if="
          ['ON_WAIT_ENTRY', 'ON_WAIT_EXIT'].includes(
            trail.order_trading_phase
          ) && trail.trail_order_status != 'REJECTED'
        "
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="orderState(trail.order_trading_phase)"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <div class="bg-ontick-blue-600 h-[8px] w-[8px] rounded-full"></div>
        </div>
      </div>

      <!-- [FINALIZADA PELO CLIENTE] Bolina cinza -->
      <!-- if (["ON_WAIT_ENTRY", "PARTIALLY_FILLED", "FILLED"].includes(this.status) && ["STOPPED"].includes(this.orderStatus)) -->
      <div
        v-else-if="
          ['ON_WAIT_ENTRY', 'PARTIALLY_FILLED', 'FILLED'].includes(
            trail.order_trading_phase
          ) && ['STOPPED'].includes(trail.trail_order_status)
        "
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Finalizado pelo cliente"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <div class="bg-ontick-steel-400 h-[8px] w-[8px] rounded-full"></div>
        </div>
      </div>

      <!-- Bolina cinza -->
      <div
        v-if="['NEW', 'ACTIVE'].includes(trail.order_trading_phase)"
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="orderState(trail.order_trading_phase)"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <div class="h-[8px] w-[8px] rounded-full bg-gray-400"></div>
        </div>
      </div>

      <!-- Check - Finalizada -->
      <div
        v-if="['FILLED'].includes(trail.order_trading_phase)"
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="orderState(trail.order_trading_phase)"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="16" height="16" rx="2" fill="#1EB866" />
            <path
              d="M6.36664 10.1L12.0166 4.45C12.15 4.31667 12.3083 4.25 12.4916 4.25C12.675 4.25 12.8333 4.31667 12.9666 4.45C13.1 4.58333 13.1666 4.74167 13.1666 4.925C13.1666 5.10833 13.1 5.26667 12.9666 5.4L6.83331 11.5333C6.69998 11.6667 6.54442 11.7333 6.36664 11.7333C6.18886 11.7333 6.03331 11.6667 5.89998 11.5333L3.03331 8.66667C2.89998 8.53333 2.83609 8.375 2.84164 8.19167C2.8472 8.00833 2.91664 7.85 3.04998 7.71667C3.18331 7.58333 3.34164 7.51667 3.52498 7.51667C3.70831 7.51667 3.86664 7.58333 3.99998 7.71667L6.36664 10.1Z"
              fill="#FAFAFA"
            />
          </svg>
        </div>
      </div>

      <!-- Ordem rejeitada -->
      <div
        v-if="
          ['ON_WAIT_ENTRY', 'PARTIALLY_FILLED', 'REJECTED'].includes(
            trail.order_trading_phase
          ) && ['REJECTED'].includes(trail.trail_order_status)
        "
        v-tippy="{ arrow: true, theme: 'green' }"
        content="Ordem rejeitada"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.3018 10.3335C7.49069 10.3335 7.64902 10.2696 7.7768 10.1418C7.90458 10.0141 7.96846 9.85572 7.96846 9.66683C7.96846 9.47794 7.90458 9.31961 7.7768 9.19183C7.64902 9.06405 7.49069 9.00016 7.3018 9.00016C7.11291 9.00016 6.95458 9.06405 6.8268 9.19183C6.69902 9.31961 6.63513 9.47794 6.63513 9.66683C6.63513 9.85572 6.69902 10.0141 6.8268 10.1418C6.95458 10.2696 7.11291 10.3335 7.3018 10.3335ZM7.3018 7.66683C7.49069 7.66683 7.64902 7.60294 7.7768 7.47516C7.90458 7.34738 7.96846 7.18905 7.96846 7.00016V4.3335C7.96846 4.14461 7.90458 3.98627 7.7768 3.8585C7.64902 3.73072 7.49069 3.66683 7.3018 3.66683C7.11291 3.66683 6.95458 3.73072 6.8268 3.8585C6.69902 3.98627 6.63513 4.14461 6.63513 4.3335V7.00016C6.63513 7.18905 6.69902 7.34738 6.8268 7.47516C6.95458 7.60294 7.11291 7.66683 7.3018 7.66683ZM7.3018 13.6668C6.37958 13.6668 5.51291 13.4918 4.7018 13.1418C3.89069 12.7918 3.18513 12.3168 2.58513 11.7168C1.98513 11.1168 1.51013 10.4113 1.16013 9.60016C0.810132 8.78905 0.635132 7.92238 0.635132 7.00016C0.635132 6.07794 0.810132 5.21127 1.16013 4.40016C1.51013 3.58905 1.98513 2.8835 2.58513 2.2835C3.18513 1.6835 3.89069 1.2085 4.7018 0.858496C5.51291 0.508496 6.37958 0.333496 7.3018 0.333496C8.22402 0.333496 9.09069 0.508496 9.9018 0.858496C10.7129 1.2085 11.4185 1.6835 12.0185 2.2835C12.6185 2.8835 13.0935 3.58905 13.4435 4.40016C13.7935 5.21127 13.9685 6.07794 13.9685 7.00016C13.9685 7.92238 13.7935 8.78905 13.4435 9.60016C13.0935 10.4113 12.6185 11.1168 12.0185 11.7168C11.4185 12.3168 10.7129 12.7918 9.9018 13.1418C9.09069 13.4918 8.22402 13.6668 7.3018 13.6668Z"
              fill="#DD5B5B"
            />
          </svg>
        </div>
      </div>

      <!-- Seta dupla para direita -->
      <span
        v-if="
          ['ON_ENTRY', 'ON_EXIT'].includes(trail.order_trading_phase) ||
          (['PARTIALLY_FILLED'].includes(trail.order_trading_phase) &&
            trail.trail_order_status != 'STOPPED')
        "
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="orderState(trail.order_trading_phase)"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <svg
            width="16"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_8472_77383)">
              <path
                d="M4.7498 11.9834L4.0498 11.2834L7.3498 7.9834L4.0498 4.6834L4.7498 3.9834L8.7498 7.9834L4.7498 11.9834ZM8.96647 11.9834L8.26647 11.2834L11.5665 7.9834L8.26647 4.6834L8.96647 3.9834L12.9665 7.9834L8.96647 11.9834Z"
                fill="#07A4FF"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_8472_77383"
                x="0.0498047"
                y="-0.0166016"
                width="16.917"
                height="16"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0235294 0 0 0 0 0.580392 0 0 0 0 0.901961 0 0 0 0.75 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_8472_77383"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_8472_77383"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </span>

      <!-- Seta dupla para esquerda -->
      <span
        v-if="
          ['ON_TP', 'ON_SL', 'ON_TIME_EXIT'].includes(trail.order_trading_phase)
        "
        v-tippy="{ arrow: true, theme: 'green' }"
        :content="orderState(trail.order_trading_phase)"
      >
        <div class="flex h-[16px] w-[16px] items-center justify-center">
          <svg
            class="rotate-180"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_8472_77383)">
              <path
                d="M4.7498 11.9834L4.0498 11.2834L7.3498 7.9834L4.0498 4.6834L4.7498 3.9834L8.7498 7.9834L4.7498 11.9834ZM8.96647 11.9834L8.26647 11.2834L11.5665 7.9834L8.26647 4.6834L8.96647 3.9834L12.9665 7.9834L8.96647 11.9834Z"
                fill="#07A4FF"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_8472_77383"
                x="0.0498047"
                y="-0.0166016"
                width="16.917"
                height="16"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0235294 0 0 0 0 0.580392 0 0 0 0 0.901961 0 0 0 0.75 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_8472_77383"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_8472_77383"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </span>
    </template>
  </div>
</template>

<script>
import StatusProgressBarExecTrailComponent from "./status-progress-bar-exec-trail.component.vue";
export default {
  components: { StatusProgressBarExecTrailComponent },
  props: {
    trail: {
      type: Object,
    },
  },
  computed: {
    operation() {
      return this.trail.trail_order_type === "BUY" ? "Compra" : "Venda";
    },
  },
  methods: {
    orderState(state) {
      switch (state) {
        case "NEW":
          return "Aguardando";
        case "ACTIVE": //bolinha cinza
          return "Ativa";
        case "ON_WAIT_ENTRY": //bolinha azul
          return "Aguardando entrada";
        case "ON_ENTRY": //seta dupla para direita
          return "Executando entrada";
        case "ON_WAIT_EXIT": //bolinha azul
          return "Aguardando saída";
        case "ON_EXIT": //seta dupla para esquerda
          return "Executando saída";
        case "ON_TP": //seta dupla para esquerda
          return "Executando TP";
        case "ON_SL": //seta dupla para esquerda
          return "Executando SL";
        case "ON_TIME_EXIT": //seta dupla para esquerda
          return "Saída por tempo";
        case "FILLED": //ícone de check
          return "Finalizada";
        case "REJECTED": //ícone de ordem rejeitada
          return "Ordem rejeitada";
        case "PARTIALLY_FILLED":
          return "Parcialmente executado";
        default:
          return state;
      }
    },
  },
};
</script>

<style></style>
